import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';

/**
 * Protection Products Action Types
 */
export const PROTECTION_PRODUCTS_ACTION = {
  LOAD: type('PROTECTION_PRODUCTS_LOAD'),
  SET: type('PROTECTION_PRODUCTS_SET'),
  CLEAR: type('PROTECTION_PRODUCTS_CLEAR')
};

/**
 * Protection Products load
 */
export class ProtectionProductsActionLoad implements ActionBase {
  public readonly type: string = PROTECTION_PRODUCTS_ACTION.LOAD;
  constructor() {}
}

/**
 * ProtectionProductsActionSet
 */
export class ProtectionProductsActionSet implements ActionBase {
  public readonly type: string = PROTECTION_PRODUCTS_ACTION.SET;
  constructor(public payload: any[]) {}
}

/**
 * ProtectionProductsActionClear
 */
export class ProtectionProductsActionClear implements ActionBase {
  public readonly type: string = PROTECTION_PRODUCTS_ACTION.CLEAR;
  constructor() {}
}

export type Any = ProtectionProductsActionLoad |
ProtectionProductsActionSet |
ProtectionProductsActionClear;
